@if (
  {
    currentUserLocation: currentUserLocationGooglePlaceId$ | async,
    searchHistory: searchHistory$ | async,
    savedSearches: savedSearches$ | async,
    googleResults: googleResults$ | async,
    canSubmit: canSubmit$ | async,
    isLargeScreen: largeScreenObserver$ | async,
    isLessThanLargeScreen: largeScreenDownObserver$ | async,
    isXXXXLScreen: xxxxlScreenUpObserver$ | async,
    searchInputFieldPlaceholder: searchInputFieldPlaceholder$ | async,
  };
  as componentData
) {
  <div class="search-wrapper" tabindex="-1" (clickOutside)="clickOutsideHandler()">
    <div class="search-controls h-100">
      <form (ngSubmit)="onSubmit(); $event.preventDefault()" class="form h-100" [ngClass]="{ 'with-button': showSearchButton }">
        <div style="position: relative">
          @if (componentData.isLessThanLargeScreen) {
            <p-iconfield>
              <input
                type="text"
                pInputText
                [placeholder]="componentData.searchInputFieldPlaceholder"
                [formControl]="searchControl"
                (click)="inputFieldClickHandler($event)"
                (focus)="inputFieldFocusHandler($event)"
                (keydown)="dropdownKeyboardNavigationHandler($event); inputFieldStopCursorShiftHandler($event)"
                class="input-element" />
              <p-inputicon class="pi pi-search" (click)="onSubmit(); $event.preventDefault()" />
            </p-iconfield>
          } @else {
            <input
              type="text"
              pInputText
              [placeholder]="componentData.searchInputFieldPlaceholder"
              [formControl]="searchControl"
              (click)="inputFieldClickHandler($event)"
              (focus)="inputFieldFocusHandler($event)"
              (keydown)="dropdownKeyboardNavigationHandler($event); inputFieldStopCursorShiftHandler($event)"
              class="input-element h-100" />
          }
          @if (showSearchButton) {
            <button
              class="d-none d-lg-inline-flex button p-button-lg search-button h-100"
              type="submit"
              aria-label="Search"
              pButton
              icon="pi pi-search"
              [disabled]="disabled || !componentData.canSubmit"></button>
          }
          @if (isDropdownVisible) {
            <div (mouseover)="dropdownMouseoverHandler($event)" class="dropdown-wrapper card card-body">
              <!-- No Results Found -->
              @if (showAdvancedSearchError) {
                <div class="group group-5">
                  <ul>
                    <li #li>No Results Found</li>
                  </ul>
                </div>
              }
              <!-- User location -->
              @if (showCurrentUserGeolocation) {
                @if (componentData.currentUserLocation) {
                  <div class="group group-1">
                    <ul>
                      <li
                        #li
                        (click)="onDropdownListElementClick()"
                        [attr.data-key]="componentData.currentUserLocation.value"
                        [attr.data-type]="searchRequestType.CURRENT_LOCATION"
                        [attr.data-description]="componentData.currentUserLocation.addressDescription"
                        class="search-result">
                        <a><fa-icon icon="map-pin" /> {{ componentData.currentUserLocation.label }}</a>
                      </li>
                    </ul>
                  </div>
                }
              }
              <!-- Google search locations -->
              @if (componentData.googleResults?.length) {
                <div class="group group-3">
                  <span class="subtitle">Search Locations</span>
                  <ul>
                    @for (data of componentData.googleResults; track data) {
                      <li
                        #li
                        (click)="onDropdownListElementClick()"
                        [attr.data-key]="data.value"
                        [attr.data-type]="searchRequestType.GOOGLE_RESULT"
                        [attr.data-description]="data.addressDescription">
                        <fa-icon icon="map-marker-alt" /> {{ data.label }}
                      </li>
                    }
                  </ul>
                </div>
              }
              <!-- Search History -->
              @if (componentData.searchHistory && showSearchHistory) {
                @if (componentData.searchHistory.length) {
                  <div class="group group-4">
                    <span class="subtitle">Search History</span>
                    <ul>
                      @for (data of componentData.searchHistory; track data) {
                        <li
                          #li
                          (click)="onDropdownListElementClick(data.label)"
                          [attr.data-key]="data.value"
                          [attr.data-type]="searchRequestType.HISTORY"
                          [attr.data-url]="data.value">
                          <fa-icon icon="map-marker-alt" /> {{ data.label }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              }
              <!-- Saved Searches -->
              @if (showSavedSearches) {
                @if (componentData.savedSearches) {
                  @if (componentData.savedSearches.length) {
                    <div class="group group-5">
                      <span class="subtitle">Saved Searches</span>
                      <ul>
                        @for (data of componentData.savedSearches; track data) {
                          <li
                            #li
                            (click)="onDropdownListElementClick()"
                            [attr.data-key]="data.value"
                            [attr.data-type]="searchRequestType.SAVED_SEARCH"
                            [attr.data-url]="data.url">
                            <fa-icon icon="map-marker-alt" /> {{ data.label }}
                          </li>
                        }
                      </ul>
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
        @if (showAdvancedSearchDropdown) {
          <div class="advancedSearchContainer">
            @if (enableSmallDropDownOnHighResolutionScreen) {
              @if (!componentData.isXXXXLScreen && !componentData.isLessThanLargeScreen) {
                <app-advanced-search-dropdown [hasLabel]="false" [formControl]="selectedValueControl" />
              }
              @if (componentData.isXXXXLScreen) {
                <app-advanced-search-dropdown [formControl]="selectedValueControl" />
              }
              @if (componentData.isLessThanLargeScreen) {
                <div class="mobile-advancedsearch">
                  <p-button
                    styleClass="mobile-advancedsearch--btn"
                    icon="pi pi-chevron-down"
                    [routerLink]="advancedSearchMobileRoutingPath.length > 0 ? advancedSearchMobileRoutingPath : ['.', 'mobile', 'advanced-search-options']" />
                </div>
              }
            }
            @if (!enableSmallDropDownOnHighResolutionScreen) {
              @if (componentData.isLargeScreen) {
                <app-advanced-search-dropdown [formControl]="selectedValueControl" />
              }
              @if (componentData.isLessThanLargeScreen) {
                <div class="mobile-advancedsearch">
                  <p-button
                    styleClass="mobile-advancedsearch--btn"
                    icon="pi pi-chevron-down"
                    [routerLink]="advancedSearchMobileRoutingPath.length > 0 ? advancedSearchMobileRoutingPath : ['.', 'mobile', 'advanced-search-options']" />
                </div>
              }
            }
          </div>
        }
      </form>
    </div>
  </div>
}
